// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"0bca7f0d","707":"7d94a6f7","904":"dca2edbb"}[chunkId] + ".chunk.js";
};